import Box from '@/components/control/components/box';
import Button from '@/components/control/components/button';
import CardImage from '@/components/control/components/card-image';
import CardText from '@/components/control/components/card-text';
import Checkbox from '@/components/control/components/checkbox';
import Choice from '@/components/control/components/choice';
import Dropdown from '@/components/control/components/dropdown';
import HiddenInput from '@/components/control/components/hidden-input';
import Input from '@/components/control/components/input';
import Label from '@/components/control/components/label';
import Radio from '@/components/control/components/radio';
import RadioLabel from '@/components/control/components/radio-label';
import RadioText from '@/components/control/components/radio-text';
import Text from '@/components/control/components/text';
import Textarea from '@/components/control/components/textarea';

export const Control = {
  Box,
  Button,
  CardImage,
  CardText,
  Checkbox,
  Choice,
  Dropdown,
  HiddenInput,
  Input,
  Label,
  Radio,
  RadioLabel,
  RadioText,
  Text,
  Textarea,
};

export default Control;
